import React from 'react';
import { Modal } from '@app/components/common/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import * as S from './DealRoomRemarkModal.styles';

interface DealRoomRemarkModalProps {
  clientReview: string;
  open: boolean;
  onClose: () => void;
}

export const DealRoomRemarkModal: React.FC<DealRoomRemarkModalProps> = ({ clientReview, open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="large"
      open={open}
      title={t('dealRooms.landing.customerRemarks')}
      closable={true}
      footer={
        <S.FooterWrapper>
          <S.FooterButtons>
            <Button onClick={onClose}>{t('dealRooms.landing.closeRemarks')}</Button>
          </S.FooterButtons>
        </S.FooterWrapper>
      }
      maskClosable={false}
      onCancel={onClose}
      destroyOnClose
    >
      <S.Wrapper dangerouslySetInnerHTML={{ __html: clientReview.replace(/\n/g, '<br/>') }} />
    </Modal>
  );
};
